import { IActionBase, IProfileState } from "../models/root.interface";
import { ADD_NAME, ADD_PICTURE, ADD_COMPANY_NAME, ADD_FULL_PROFILE } from "../actions/profile.action";

const initialState: IProfileState = {
   name: "",
   picture: "",
   companyName: "",
   fullProfile: {},
};

function profileReducer(state: IProfileState = initialState, action: IActionBase): IProfileState {
    switch (action.type) {

        case ADD_NAME: {
            return {...state, name: action.name};
        }

        case ADD_PICTURE: {
            return {...state, picture: action.picture};
        }

        case ADD_COMPANY_NAME: {
            return {...state, companyName: action.campanyName};
        }

        case ADD_FULL_PROFILE: {
            return {...state, fullProfile: action.profile};  
        }

        default:
            return state;
    }
}


export default profileReducer;